import { Model } from '../parents/model';
import { UserModel } from './user.model';

export class MeModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_USER = 'user';
  static ATTR_PERMISSIONS = 'permissions';
  static ATTR_ALLOWED_STOCK = 'allowed_order_shipment_stock_ids';

  get user() {
    return new UserModel(this.attributes[MeModel.ATTR_USER]);
  }

  get permissions() {
    return this.attributes[MeModel.ATTR_PERMISSIONS];
  }

  get allowedStockIds() {
    return this.user.attributes[MeModel.ATTR_ALLOWED_STOCK];
  }

  get firstAllowedStock() {
    if (this.allowedStockIds && this.allowedStockIds.length) {
      return this.allowedStockIds[0];
    }
    return null;
  }
}
